import React from 'react';
import styles from './CommingSoon.module.scss';
import HeaderSection from '../../organism/headerSection/HeaderSection';
import Footer from '../homePageSections/footer/Footer';
import ComingSoonContainer from './ComingSoonContainer';

const CommingSoonPage = () => {
  return (
    <div className={styles.background}>
      <ComingSoonContainer />
    </div>
  );
};

export default CommingSoonPage;
